export default "__VITE_ASSET__1psQY8Kj__"